
import { connect } from 'react-redux';
import OrderGrid from './order-grid';
import { proceedOrder, declineOrder, selectOrderForDeliveryInfo } from '../../reducers/order.reducers';
import { openAlert } from '../../reducers/alert.reducers';
import { getVisibleOrders } from '../../reselect/order.selector';

const mapStateToProps = state => ({
  orders: getVisibleOrders(state),
  searchOrders: state.orders.orders,
  loading: state.orders.loading,
  orderSearchValue: state.orders.orderSearchValue,
});

const mapDispatchToProps = dispatch => ({
  proceedOrder: orderId => dispatch(proceedOrder(orderId)),
  declineOrder: orderId => dispatch(openAlert({
    title: 'Wirklich ablehnen?',
    message: 'Wollen sie diese Bestellung wirklich ablehnen?',
    onAgreeAction: declineOrder(orderId),
    onDismissAction: null })),
  openDeliveryDialog: order => dispatch(selectOrderForDeliveryInfo(order)),
});

export default connect(mapStateToProps, mapDispatchToProps)(OrderGrid);
